import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { useNavigate } from "react-router-dom";
import { clearDatahandling } from "../../../utils/clearDataHandling";
import { useDispatch } from "react-redux";
import BookingList from "./BookingList";
import UpcomingBookings from "../../../components/common/UpcomingBookings/UpcomingBookings";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function Booking() {
  const [value, setValue] = React.useState(0);
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  React.useEffect(() => {
    clearDatahandling(dispatch)

  }, [])

  return (
    <div className="Dashboard-page-main">
      <div className="Dashboard-page-wrap">
        <div className="booking-tab-wrap max-720">
          <div className="upcoming-sec">
            <h2>My Bookings</h2>

            <Box sx={{ width: "100%" }}>
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <Tabs
                  value={value}
                  onChange={handleChange}
                  aria-label="basic tabs example"
                >
                  <Tab label="Upcoming" {...a11yProps(0)} />
                  <Tab label="History" {...a11yProps(1)} />
                </Tabs>
              </Box>
              <CustomTabPanel
                value={value} index={0}>
                <BookingList status={'Upcoming'} />
              </CustomTabPanel>
              <CustomTabPanel value={value} index={1}>
                {/* <UpcomingBookings /> */}
                <BookingList status={''} />
              </CustomTabPanel>
            </Box>
          </div>
        </div>
      </div>
    </div>
  );
}
